exports.install = function (Vue) {
  if (this.installed) {
    return
  }

  this.installed = true

  var dateFormats = ['yyyy-MM-dd', 'yyyy/MM/dd']

  window.Parsley.addValidator('tel', telValidator)
  window.Parsley.addValidator('invalid', invalidValidator)
  window.Parsley.addValidator('afterDate', afterDateValidator)
  window.Parsley.addValidator('beforeDate', beforeDateValidator)

  function telValidator (value) {
    var telParts = value.split('-')

    if (telParts.length < 2) {
      return false
    }

    var telZip = telParts[0]
    var tel = telParts[1]
    var telExt = telParts.length === 3 ? telParts[2] : ''

    if (/^0[\d]{1,2}/.test(telZip) === false) {
      return false
    }

    if (/^[\d]{6,8}$/.test(tel) === false) {
      return false
    } else {
      if (telZip.length === 2 && tel.length !== 8) {
        return false
      } else if (telZip.length === 3 && tel.length !== 6) {
        return false
      }
    }

    if (telParts.length === 3 && /^[\d]+$/.test(telExt) === false) {
      return false
    }

    return true
  }

  function invalidValidator (value, requirement) {
    return !requirement
  }

  function afterDateValidator (value, requirement) {
    var date = Date.parseExact(value, dateFormats)
    var compareDate = Date.parseExact(requirement, dateFormats)

    if (!compareDate) {
      compareDate = Date.parse(requirement)
    }

    if (!date) {
      return false
    }

    if (!compareDate) {
      return false
    }

    return date.compareTo(compareDate) >= 0
  }

  function beforeDateValidator (value, requirement) {
    var date = Date.parseExact(value, dateFormats)
    var compareDate = Date.parse(requirement, dateFormats)

    if (!compareDate) {
      compareDate = Date.parse(requirement)
    }

    if (!date) {
      return false
    }

    if (!compareDate) {
      return false
    }

    return date.compareTo(compareDate) <= 0
  }
}



// WEBPACK FOOTER //
// ./src/configs/parsleyjs/validators.js